module.exports = __webpack_public_path__ + "img/2_uk.60b93b2e.svg";